<template>
  <div>
    <payment @pay="pay" />
  </div>
</template>

<script>
  import Payment from 'src/views/Credit/components/Payment'

  export default {
    name: "buy-credit",
    components: {
      Payment
    },
    methods: {
      pay (creditPurchaseRequest, callback) {
        this.$api.postCreditPurchase(creditPurchaseRequest)
          .then(response => {
            this.$store.commit('addCurrentCredit', response.data.total)
            this.$router.push('/credit/history/' + response.data.id)
          })
          .catch(error => {
            callback(false)
          })
      }
    }
  }
</script>